import { StandardEvents } from '@shopify/events';

// Observe existing theme events without changing requests, navigation or consent.
// Send fixed event names only; never send cart contents, form values or error text.
/** @param {string} name */
function record(name) {
  try {
    if (typeof window.clarity === 'function') window.clarity('event', name);
  } catch {
    // Analytics failures must not affect shopping.
  }
}

/** @param {import('@shopify/events').CartLinesUpdateEvent} event */
async function recordCartAddition(event) {
  if (event.action !== 'add' || !event.promise) return;

  record('sa_add_to_cart_attempt');

  try {
    const result = await event.promise;

    if (result?.detail?.didError === true) {
      record('sa_add_to_cart_rejected');
    } else if (result?.cart && result?.detail?.didError === false) {
      record('sa_add_to_cart_success');
    } else {
      record('sa_add_to_cart_unconfirmed');
    }
  } catch {
    // A rejected promise can also mean the cart refresh failed after an add.
    record('sa_add_to_cart_unconfirmed');
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, recordCartAddition);

// A submit identifies checkout intent, not a loaded checkout or completed order.
// Delegation survives cart re-rendering and includes keyboard submission.
document.addEventListener('submit', (event) => {
  const submitter = event.submitter;

  if (!(submitter instanceof HTMLButtonElement) || submitter.name !== 'checkout' || submitter.disabled) return;

  queueMicrotask(() => {
    if (!event.defaultPrevented) record('sa_checkout_intent');
  });
});

const template = document.querySelector('main[data-template]')?.dataset.template?.split('.')[0];

if (template === 'product') record('sa_product_view');
if (template === 'cart') record('sa_cart_page_view');
